const normalizeBearerToken = (value: string | null | undefined): string | null => {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  return trimmed.replace(/^Bearer\s+/i, '');
};

export const mintSnapshotEntitlements = async (
  accessToken: string | null | undefined
): Promise<void> => {
  const token = normalizeBearerToken(accessToken);
  const headers: HeadersInit = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch('/api/auth/snapshots-cookie', {
    method: 'POST',
    headers,
    credentials: 'include',
  });

  if (!response.ok) {
    const payload = await response.text().catch(() => '');
    throw new Error(`Failed to mint snapshot entitlements (${response.status}): ${payload.slice(0, 200)}`);
  }
};
